import ContactForm from "./ContactForm"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Contact = () => {
    const {t} = useTranslation()
    return (
        <section className="my-8" >
                <h2 id="contact" className="text-orange-600 text-center text-5xl font-bold">{t('contacth2')}</h2>
            
            <div className="md:flex md:justify-evenly">
                    <ContactForm/>
                <div className="contactdiv1 flex flex-col justify-evenly my-24 w-full sm:w-2/4 text-center">
                <p className="text-center text-5xl font-bold text-sky-700 px-2">
                    {t('contactp1')}  
                </p>
                <p className="font-bold text-center font-bold text-5xl text-orange-600 py-4">
                    {t('contactp2')}
                </p> 
                    
                
                    <button className="bg-sky-700 hover:bg-sky-500 text-white font-bold mt-8 py-4 px-10 rounded-full self-center "> 
                    <Link to="/bookacall">
                    {t('contactbtn')}
                    </Link>
                    </button>
                </div>
            </div>
        </section>
    )
}

export default Contact